export let getIndiaFormatCurrency = (num) => {
    // function formatToIndianSystem(num) {
    if (num < 1000) {
        return num.toLocaleString('en-IN');
    } else if (num >= 1000 && num < 100000) {
        return (num / 1000).toFixed(2) + 'K';
    } else if (num >= 100000 && num < 10000000) {
        return (num / 100000).toFixed(2) + 'L';
    } else if (num >= 10000000) {
        return (num / 10000000).toFixed(2) + 'Cr';
    }
    // }
    // return n.toLocaleString('en-IN', {
    //     maximumFractionDigits: 2,
    //     style: 'currency',
    //     currency: 'INR'
    // })
}

export let getIndiaFormatNumber = (n) => {
    return n.toLocaleString('en-IN', {
        maximumFractionDigits: 2,
    })

}